
// src/web/components/group-remind-panel.jsx

import React from 'react'
import connect from '../../connects/group-report-panel'
import {
  Card,
  CardText,
} from 'react-toolbox/lib/card'
import theme from './themes/flat-card.css'
import Checkbox from "react-toolbox/lib/checkbox";
import DatePicker from "./date-picker";
import {Input} from "react-toolbox/lib/input";

class GroupReportPanel extends React.Component {
  render() {
    const {
      t,
      ui,
      group,
      isWeeklyReport,
      isMonthlyReport,
      weeklyReportStartDate,
      monthlyReportStartDate,
      inputDiaryUserCount,
      updateIsWeeklyReport,
      updateIsMonthlyReport,
      updateWeeklyReportStartDate,
      updateMonthlyReportStartDate,
      updateInputDiaryUserCount,
    } = this.props
    return (
      <Card theme={theme} className={theme.settingsCard}>
        <CardText className={theme.settingsCardContent}>
          
          <strong>{t('label:週間レポート')}</strong>
          <Checkbox label={t('label:週間レポートを出力する')}
                    className={theme.settingsCheckbox}
                    checked={isWeeklyReport}
                    onChange={(value) => updateIsWeeklyReport(this.props, value)}/>
          <CardText className={theme.settingsSubSection}>
            <strong>{t('label:週間レポート出力開始日')}</strong>
            <DatePicker value={weeklyReportStartDate}
                        className={theme.settingsDatePicker}
                        onChange={(date) => updateWeeklyReportStartDate(this.props, date)}/>
          </CardText>

          <strong>{t('label:月間レポート')}</strong>
          <Checkbox label={t('label:月間レポートを出力する')}
                    className={theme.settingsCheckbox}
                    checked={isMonthlyReport}
                    onChange={(value) => updateIsMonthlyReport(this.props, value)}/>
          <CardText className={theme.settingsSubSection}>
            <strong>{t('label:月間レポート出力開始日')}</strong>
            <DatePicker value={monthlyReportStartDate ? monthlyReportStartDate : new Date("2024-09-01")}
                        className={theme.settingsDatePicker}
                        onChange={(date) => updateMonthlyReportStartDate(this.props, date)}/>
          </CardText>
        </CardText>
      </Card>
    )
  }
}

export const RawGroupReportPanel = GroupReportPanel
export default connect(GroupReportPanel)



// WEBPACK FOOTER //
// ./src/web/components/group-report-panel.jsx